import { avationPlcInstance, leshaBankInstance, mtInstance } from "../../../shared_elements/components";

export const addEoa = {
  name:'',
  description:''
}
export const EoaHd = [
  { label: 'Name', sortOption: false },
  { label: 'Description', sortOption: false },
  ...(leshaBankInstance || mtInstance || avationPlcInstance ?
    [{ label: 'Component', sortOption: false },
    { label: 'Amount', sortOption: false },
    { label: 'Completion Date', sortOption: false },]
    : []
  ),
  { label: 'Attachment(s)', sortOption: false },
  { label: 'Action(s)', sortOption: false },
];
export const errorCode = {
  name:{
    0:'',
    1: 'Please enter Name '
  },
  eoaObj: {
    required: true
  }
}
